import React, { PureComponent } from 'react';
import { get, reduce, isEqual, includes } from 'lodash';
import { withRouter } from 'react-router-dom';

const filtersToParams = (data, filterDecoders = []) =>
  reduce(
    data,
    (res, { values, operator, key }) => ({
      ...res,
      ...(filterDecoders[key]
        ? filterDecoders[key]({ values, operator, key })
        : { [key]: values[0] }),
    }),
    {},
  );

const filtersFromParams = (filters, name, encodeFilter) => {
  const filter = get(filters, name);

  if (typeof encodeFilter === 'function') {
    return encodeFilter(filters, name);
  }

  if (!filter) return undefined;

  return {
    operator: 'contains',
    values: [filter],
    type: 'text',
    key: name,
  };
};

const orderFromParams = (sort, name) => {
  if (!sort) return undefined;

  if (includes(sort, name)) {
    return includes(sort, ',desc') ? 'ORDER_DESCENDING' : 'ORDER_ASCENDING';
  }

  return undefined;
};

const withTableActions = (WrapppedComponent) =>
  class WithTableActions extends PureComponent {
    state = {
      query: {
        page: 1,
        limit: 50,
        sort: 'filter_by_creation_date,desc',
      },
    };

    getQuery = () => {
      return this.state.query;
    };

    isNewQuery = (oldProps) => {
      const {
        query: {
          page: prevPage,
          limit: prevLimit,
          sort: prevSort,
          filters: prevFilters,
        },
      } = oldProps;
      const { page, limit, sort, filters } = this.getQuery();

      const newQuery =
        prevPage !== page ||
        prevLimit !== limit ||
        prevSort !== sort ||
        !isEqual(filters, prevFilters);

      return newQuery;
    };

    updateQuery = (updatedQuery) => {
      this.setState((state) => {
        return { query: { ...state.query, ...updatedQuery } };
      });
    };

    handleFiltersChange = (decoders) => (data) => {
      this.updateQuery({
        filters: filtersToParams(data, decoders),
        page: 1, // @Note: Return user back to first page, when filter changed
      });
    };

    handleLimitChange = (event) => {
      this.updateQuery({
        limit: event.target.value,
        page: 1, // @Note: Return user back to first page, when limit changed
      });
    };

    handlePageChange = (_event, page) => {
      this.updateQuery({ page });
    };

    handleSortChange = (data) => {
      const order = data.order === 'ORDER_ASCENDING' ? 'asc' : 'desc';

      return (
        data.key &&
        this.updateQuery({
          sort: `${data.key},${order}`,
          page: 1, // @Note: Return user back to first page, when sort changed
        })
      );
    };

    render() {
      return (
        <WrapppedComponent
          {...this.props}
          query={this.state.query}
          getTableQuery={this.getQuery}
          isNewQuery={this.isNewQuery}
          orderFromParams={orderFromParams}
          filtersFromParams={filtersFromParams}
          handleFiltersChange={this.handleFiltersChange}
          handleLimitChange={this.handleLimitChange}
          handlePageChange={this.handlePageChange}
          handleSortChange={this.handleSortChange}
        />
      );
    }
  };

export const withRouterQuery = (component) =>
  withRouter(withTableActions(component));
